import { render, staticRenderFns } from "./QROTPTimer.vue?vue&type=template&id=606ff5fd&scoped=true"
import script from "./QROTPTimer.vue?vue&type=script&lang=js"
export * from "./QROTPTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606ff5fd",
  null
  
)

export default component.exports